import { SVGProps, Ref, forwardRef } from 'react';

export const CalendarFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M.528 7.365Q.508 7.9.5 8.5c.07 6.105 1.169 7 7.5 7s7.43-.895 7.5-7q-.007-.6-.028-1.135z"
                    fill="currentColor"
                />
                <path
                    d="M.628 5.965h14.744c-.304-2.744-1.222-3.848-3.675-4.253V.5h-1.4v1.06A36 36 0 0 0 8 1.5c-.86 0-1.624.017-2.301.06V.5h-1.4v1.212c-2.45.406-3.367 1.51-3.67 4.253"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
CalendarFilledSize16Glyph.displayName = 'CalendarFilledSize16Glyph';
